import { theme } from 'antd';
import LockerAppMobile from 'assets/images/apps/LockerAppMobile.png';
import { LogoLockerNoBackground } from 'assets/images/svg/Logos';
import { DropdownWorkspace } from 'mainDashboard/TopBar/components';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Flex, Image, Row, Typography } from 'zui/Antd';
import LogoutModal from '../LogoutModal';

const { Text } = Typography;

const DownloadLockersBody = ({ showDropdown = false }) => {
	// Hooks
	const {
		token: { colorPrimary, colorPrimaryBg, colorBorder, marginXL, margin, fontWeightStrong, fontSizeHeading2 }
	} = theme.useToken();

	// Redux State
	const { isActive } = useSelector((state) => state.Auth.selectedProfile) || {};

	// Local State
	const [openSignOutModal, setOpenSignOutModal] = useState(false);

	const Applications = useMemo(
		() => [
			{
				nameApp: 'Zezamii Lockers',
				linkPlayStore: 'https://play.google.com/store/apps/details?id=com.zezamii.openlocker',
				linkAppStore: 'https://apps.apple.com/au/app/open-locker/id6455258264',
				badgeGoogleStore: (
					<Image
						width={216}
						height={90}
						alt='Get it on Google Play'
						src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
						preview={false}
					/>
				),
				badgeAppleStore: (
					<Image
						width={216}
						height={64}
						src='https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/white/en-us?releaseDate=1691625600'
						alt='Get it on App Store'
						preview={false}
					/>
				)
			}
		],
		[]
	);

	return (
		<Row gutter={[115, 115]} style={{ padding: 95 }} align={'middle'}>
			<Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
				<Flex vertical align='center'>
					<LogoLockerNoBackground width={103} height={109} />
					<Text
						style={{
							color: colorPrimary,
							textAlign: 'center',
							fontSize: fontSizeHeading2,
							fontWeight: fontWeightStrong
						}}
					>
						Zezamii Lockers
					</Text>
					<Text style={{ fontSize: 18, lineHeight: '24px', textAlign: 'center', marginBottom: margin }}>
						Download our Zezamii Lockers mobile app today for seamless access.
					</Text>

					{Applications.map((app, key) => (
						<Flex key={key} justify='center' align='center' gap={10}>
							<a href={app.linkPlayStore} target='_blank' rel='noreferrer'>
								{app.badgeGoogleStore}
							</a>
							<a href={app.linkAppStore} target='_blank' rel='noreferrer'>
								{app.badgeAppleStore}
							</a>
						</Flex>
					))}

					{showDropdown && (
						<Flex vertical gap={12} align='center' justify='center' style={{ marginTop: marginXL }}>
							{isActive ? (
								<Text style={{ textAlign: 'center' }}>
									You need additional permissions to Zezamii Lockers dashboard. <br /> Please contact
									your administrator.
								</Text>
							) : (
								<Text style={{ textAlign: 'center' }}>
									Your account has been disabled. Please contact your administrator to request
									reactivation.
								</Text>
							)}

							<Text style={{ marginTop: margin }}>Change Organisation</Text>

							<div style={{ border: `1px solid ${colorBorder}`, borderRadius: 8 }}>
								<DropdownWorkspace />
							</div>

							<Text>Or</Text>

							<LogoutModal open={openSignOutModal} setOpen={setOpenSignOutModal} />
						</Flex>
					)}
				</Flex>
			</Col>

			<Col xxl={12} xl={12} lg={12} md={0} sm={0} xs={0}>
				<Flex vertical align='center'>
					<Flex
						vertical
						align='center'
						justify='center'
						style={{
							width: 432,
							height: 432,
							borderRadius: '50%',
							backgroundColor: colorPrimaryBg
						}}
					>
						<Image src={LockerAppMobile} alt='Locker App Mobile' preview={false} />
					</Flex>
				</Flex>
			</Col>
		</Row>
	);
};

export default DownloadLockersBody;
